import React, { useState } from 'react';
import api from '../Service/api';
import './CategoryForm.css';

function CategoryForm() {
  const [categoryName, setCategoryName] = useState('');
  const [products, setProducts] = useState([
    { 
      productName: '', 
      purchasePrice: '', 
      sellPrice: ''
    }
  ]);

  const handleProductChange = (index, field, value) => {
    const newProducts = [...products];
    newProducts[index][field] = value;
    setProducts(newProducts);
  };

  const addProductRow = () => {
    setProducts([...products, { 
      productName: '', 
      purchasePrice: '', 
      sellPrice: ''
    }]);
  };

  const removeProductRow = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!categoryName.trim()) {
      alert("Please enter category name");
      return;
    }

    // Check each product
    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      
      if (!product.productName.trim()) {
        alert(`Please enter product name for row ${i + 1}`);
        return;
      }
      
      // No size validation for any category anymore
    }

    const payload = {
      categoryName,
      products: products.map(p => ({
        productName: p.productName,
        purchasePrice: parseFloat(p.purchasePrice) || 0,
        sellPrice: parseFloat(p.sellPrice) || 0
      }))
    };

    try {
      const res = await api.post('/api/category/addCategoryWithProducts', payload);

      if (res.data.code === 1) {
        alert(res.data.additionalDetail || res.data.message);
        setCategoryName('');
        setProducts([{ 
          productName: '', 
          purchasePrice: '', 
          sellPrice: ''
        }]);
      } else {
        alert(res.data.additionalDetail || res.data.message);
      }

    } catch (err) {
      console.error("Backend error:", err);
      const msg =
        err.response?.data?.additionalDetail ||
        err.response?.data?.message ||
        "Something went wrong";
      alert(msg);
    }
  };

  return (
    <div className="category-form-container">
      <h2>Add Category</h2>
      <input
        type="text"
        className="category-input"
        placeholder="Category Name"
        value={categoryName}
        onChange={(e) => setCategoryName(e.target.value)}
      />

      <div style={{ overflowX: "auto", width: "100%" }}>
        <table className="category-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Purchase Price</th>
              <th>Sell Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, idx) => (
              <tr key={idx}>
                <td>
                  <input
                    type="text"
                    value={p.productName}
                    onChange={(e) => handleProductChange(idx, 'productName', e.target.value)}
                    placeholder="Product name"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={p.purchasePrice}
                    onChange={(e) => handleProductChange(idx, 'purchasePrice', e.target.value)}
                    placeholder="Purchase price"
                    step="0.01"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={p.sellPrice}
                    onChange={(e) => handleProductChange(idx, 'sellPrice', e.target.value)}
                    placeholder="Sell price"
                    step="0.01"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                </td>
                <td>
                  <button className="remove-btn" onClick={() => removeProductRow(idx)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "15px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <button className="add-btn" onClick={addProductRow}>Add Product</button>
        <button className="save-btn" onClick={handleSubmit}>Save Category</button>
      </div>
    </div>
  );
}

export default CategoryForm;